import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { MetricDetailsTab } from 'webapp/enums/enums';

import CommonPopupsDrawerComponent from 'webapp/components/common/popups/drawer';
import ForecastsMyGridComponent from 'webapp/components/forecasts/my/grid';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

import type Forecast from 'webapp/models-custom/forecast';

import type MetricDetailsService from 'webapp/services/metric-details';

export default class ForecastsDrawerPopupComponent extends PopupInnerModalComponent {
	@service('model-manager/forecasts')
	declare mmForecastsService: Service.ModelManager.Forecasts;
	@service('model-manager/metrics')
	declare mmMetricsService: Service.ModelManager.Metrics;
	@service('metric-details')
	declare metricDetailsService: MetricDetailsService;
	@service('analytics') declare analyticsService: Service.Analytics;

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		void this.mmMetricsService.requestMetrics();
		void this.mmForecastsService.requestForecastsData();
		this.analyticsService.page('Saved Forecasts');
	}

	@action
	openDetailsInDrawer(model: Forecast): void {
		this.close();

		this.metricDetailsService.openMetricDetailsDrawer(
			{
				metricSetup: model.metricSetup,
				tab: MetricDetailsTab.FORECAST,
				forecast: { forecastId: model.id },
			},
			'saved_forecasts',
		);
	}

	<template>
		<CommonPopupsDrawerComponent @icon="Forecasts" @onClose={{this.close}}>
			<:header>
				<div class="text">All saved forecasts</div>
			</:header>
			<:content>
				<div class="view-grid">
					<ForecastsMyGridComponent @onOpenDetails={{this.openDetailsInDrawer}} />
				</div>
			</:content>
		</CommonPopupsDrawerComponent>
	</template>
}
